import clsx from "clsx";
import { forwardRef } from "react";

import { ReactComponent as CheckIcon } from "assets/icons/check.svg";

interface Props {
  label?: string;
  checked?: boolean;
  onChange?: () => void;
  className?: string;
}

const RawCheckbox = forwardRef<HTMLInputElement, Props>(
  ({ label, checked, onChange, className }, ref) => {
    return (
      <label
        className={clsx(
          "relative h-5 inline-flex items-center",
          label ? "pl-8" : "pl-5",
          className,
        )}
      >
        {label}
        <input
          ref={ref}
          className="absolute w-0 h-0 opacity-0 cursor-pointer peer"
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <span className="absolute left-0 top-0 size-5 rounded-[3px] border-2 border-[rgba(102,112,128,0.3)] bg-white inline-flex justify-center items-center peer-checked:bg-primary">
          <CheckIcon color="white" className="size-4" />
        </span>
      </label>
    );
  },
);

RawCheckbox.displayName = "RawCheckbox";

export default RawCheckbox;
